export const makeSoccerAbbreviation = (teamName) => {
    if (!teamName) return "";
    const [first, second, ...rest] = teamName.toUpperCase().split(" ");
    if (second) return `${first[0]}. ${second.slice(0,3)}`;
    return first.slice(0,3);
}